import { Card, CardContent, FormControlLabel, FormGroup, Grid, Switch, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IStorageRequest, IStorageRequestProps } from "../../interfaces";
import { FormSectionHeader } from "../Shared/FormSectionHeader";

export const DeliveryInformationForm: React.FC<IStorageRequestProps> = ({
    storageRequest,
    onUpdate,
    readonly,
    saving,
    ...props
}) => {


    const [model, setModel] = useState<IStorageRequest | null>(storageRequest ?? null);


    useEffect(() => {
        if (storageRequest) {
            console.log("setting SR and projectCodeRequired is", storageRequest.projectCodeRequired);

            setModel(storageRequest);

        }
    }, [storageRequest])


    const handleChange = (property: string, value: any) => {



        setModel((prev) => {


            console.log("changing and projectCodeRequired is", prev?.projectCodeRequired);

            return {
                ...prev,
                [property]: value
            } as IStorageRequest
        });


        onUpdate(property, value);
    }


    useEffect(() => {

        console.log("projectCodeRequired is", model?.projectCodeRequired);

    },[model])

    return (
        <>
            <Card sx={{ height: "100%" }} >
                <FormSectionHeader label="Delivery Info" saving={saving} />
                <CardContent>
                    {model &&
                        <Grid container spacing={2}>
                            <Grid item xs={3} >
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    inputProps={{ min: 0 }}
                                    label="Number of standard pallets?"
                                    value={model?.standardPallets ?? 0}
                                    onChange={(e) => handleChange("standardPallets", Number(e.currentTarget.value ?? "0"))}
                                    helperText="If this is a large delivery with muliple mixed content pallets, please email stores@porterbrook.co.uk a list of conents per pallet. This will help us process the delivery"
                                    disabled={readonly}
                                    required
                                />
                            </Grid>
                            <Grid item xs={5} >
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    minRows={3}
                                    label="Any non-standard pallets?"
                                    value={model?.nonStandardPallets}
                                    onChange={(e) => handleChange("nonStandardPallets", e.currentTarget.value)}
                                    helperText="Please provide as much information as possible of the size/type of stillage. If all standard state 'N /A' "
                                    disabled={readonly}
                                    required
                                />
                            </Grid>
                            <Grid item xs={4} >
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    minRows={3}
                                    label="Any other info?"
                                    value={model?.otherDeliveryInfo}
                                    onChange={(e) => handleChange("otherDeliveryInfo", e.currentTarget.value)}
                                    disabled={readonly}
                                />
                            </Grid>



                            <Grid item xs={12}>
                                <FormGroup>
                                    <FormControlLabel label={"Asset Protection to arrange courier?"} control={
                                        <Switch
                                            color="primary"
                                            checked={model?.projectCodeRequired === true}
                                            disabled={readonly}
                                            onChange={(e, checked) => handleChange("projectCodeRequired", checked ? true : false)}
                                        />
                                    } />
                                </FormGroup>

                            </Grid>
                            {model?.projectCodeRequired === true && <>
                                <Grid item xs={4}>
                                    <TextField
                                        fullWidth
                                        required
                                        variant="outlined"
                                        label="Project Code"
                                        value={model.projectCode}
                                        onChange={(e) => handleChange("projectCode", e.currentTarget.value)}
                                        disabled={readonly}
                                        helperText="To book courier costs"
                                    />
                                </Grid>
                                <Grid xs={8} />
                                <Grid item xs={4}>
                                    <TextField
                                        fullWidth
                                        required
                                        variant="outlined"
                                        label="Contact Name"
                                        value={model?.collectionContactName}
                                        onChange={(e) => handleChange("collectionContactName", e.currentTarget.value)}
                                        disabled={readonly}
                                    />
                                </Grid>
                                <Grid item xs={4}>

                                </Grid>
                                <Grid item xs={4} />
                                <Grid item xs={4}>
                                    <TextField
                                        fullWidth
                                        required
                                        variant="outlined"
                                        label="Address Line 1"
                                        value={model?.collectionAddressLine1}
                                        onChange={(e) => handleChange("collectionAddressLine1", e.currentTarget.value)}
                                        disabled={readonly}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        fullWidth
                                        required
                                        variant="outlined"
                                        label="Address Line 2"
                                        value={model?.collectionAddressLine2}
                                        onChange={(e) => handleChange("collectionAddressLine2", e.currentTarget.value)}
                                        disabled={readonly}
                                    />
                                </Grid>
                                <Grid item xs={4} >
                                    <TextField
                                        fullWidth
                                        required
                                        variant="outlined"
                                        label="City"
                                        value={model?.collectionCity}
                                        onChange={(e) => handleChange("collectionCity", e.currentTarget.value)}
                                        disabled={readonly}
                                    />
                                </Grid>
                                <Grid item xs={4} >
                                    <TextField
                                        fullWidth
                                        required
                                        variant="outlined"
                                        label="Postcode"
                                        value={model?.collectionPostcode}
                                        onChange={(e) => handleChange("collectionPostcode", e.currentTarget.value)}
                                        disabled={readonly}
                                    />
                                </Grid>
                                <Grid item xs={4} >
                                    <TextField
                                        fullWidth
                                        required
                                        variant="outlined"
                                        label="Contact Number"
                                        value={model?.collectionContactNumber}
                                        onChange={(e) => handleChange("collectionContactNumber", e.currentTarget.value)}
                                        disabled={readonly}
                                    />
                                </Grid>
                                <Grid item xs={4} >
                                    <TextField
                                        fullWidth
                                        required
                                        variant="outlined"
                                        type="email"
                                        label="Contact Email"
                                        value={model?.collectionContactEmail}
                                        onChange={(e) => handleChange("collectionContactEmail", e.currentTarget.value)}
                                        disabled={readonly}
                                    />
                                </Grid>
                            </>
                            }

                        </Grid>
                    }
                </CardContent>
            </Card>
        </>
    );
}